import { currencyWithDecimals } from '../../../../../common/utils/shared';
import { StyledDangerSpan } from './styled';

export const dispCurrency = (c, isZeroBased = false) => {
  if (c === null || c === undefined || Number.isNaN(c)) return '--';
  const result = Math.round(c);
  const isRed = isZeroBased ? result > 0 : result < 0;
  const formatted =
    result < 0
      ? `-${currencyWithDecimals(Math.abs(result))}`
      : `$${result}`;
  if (isRed) {
    return <StyledDangerSpan>{formatted}</StyledDangerSpan>;
  }
  return formatted;
};

export const dispDiscount = (discountPoints, base = 100) => {
  if (
    discountPoints === null ||
    discountPoints === undefined ||
    Number.isNaN(discountPoints)
  )
    return '--';
  const result = discountPoints.toFixed(3);
  const isRed = base === 0 ? Number(result) > 0 : Number(result) < 0;
  if (isRed) {
    return <StyledDangerSpan>{result}</StyledDangerSpan>;
  }
  return result;
};
